export default __webpack_public_path__ + "static/media/ghost.7464784a.jpg";